const keywords = new Set([
  'asc',
  'category',
  'date_created',
  'date_modified',
  'desc',
  'exp_factor_',
  'for',
  'file',
  'id',
  'length',
  'node_def_uuid',
  'owner_uuid',
  'parent_id',
  'parent_uuid',
  'props_advanced',
  'props_draft',
  'props',
  'record',
  'record_cycle',
  'record_step',
  'record_uuid',
  'step',
  'taxonomy',
  'unique',
  'uuid',
  'value',
  'weight',
])

export const isKeyword = (value: unknown): boolean => keywords.has(value as string)
